import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        textAlign: "center",
        bgcolor: "#f9f9f9",
      }}
    >
      {/* Error Icon */}
      <ErrorOutlineIcon sx={{ fontSize: 80, color: "#d32f2f", mb: 2 }} />

      {/* 404 Title */}
      <Typography variant="h3" sx={{ fontWeight: "bold", color: "#333" }}>
        404 - Page Not Found
      </Typography>

      {/* Message */}
      <Typography variant="body1" sx={{ color: "#666", mt: 1, mb: 3 }}>
        Oops! The page you're looking for doesn't exist or has been moved.
      </Typography>

      {/* Back to Home Button */}
      <Button
        variant="contained"
        color="primary"
        onClick={() => navigate(-1)}
        sx={{ textTransform: "none", fontSize: 16, px: 4, py: 1 }}
      >
        Go Back
      </Button>
    </Box>
  );
};

export default NotFound;
